/* override functions api.jquery.js */
Shopify.onItemAdded = function (line_item) {
  Shopify.getCart();
};

Shopify.onCartUpdate = function (cart) {
  Shopify.cartUpdateInfo(cart, ".single-cart-item-loop");
};

Shopify.onError = function (XMLHttpRequest, textStatus) {
  var data = eval("(" + XMLHttpRequest.responseText + ")");
  var str = "";

  // Testo dell'errore in italiano da intercettare
  var italianError =
    "Nel carrello è già presente la quantità massima consentita per questo articolo.";

  // 1. Controlla se il messaggio di errore è quello specifico sulla quantità massima
  if (data.description && data.description.includes(italianError)) {
    // Controlla la lingua corrente e imposta la traduzione
    // Assumiamo che la variabile della lingua sia accessibile, altrimenti la si può forzare
    var currentLocale = jQuery("html").attr("lang") || Shopify.locale;

    if (currentLocale && currentLocale.toLowerCase().includes("de")) {
      // Tedesco
      str =
        "Die maximal zulässige Menge für diesen Artikel befindet sich bereits im Warenkorb.";
    } else if (currentLocale && currentLocale.toLowerCase().includes("fr")) {
      // Francese
      str =
        "La quantité maximale autorisée pour cet article est déjà dans votre panier.";
    } else {
      // Ritorna alla descrizione dell'errore di base se la lingua non è gestita
      str = data.description;
    }
  } else if (!!data.message) {
    // 2. Se è un altro messaggio generico, usa la descrizione fornita da Shopify
    str = data.description;
  } else {
    // 3. Se è un errore sconosciuto, usa il formato di errore generico
    str = "Error : " + Shopify.fullMessagesFromErrors(data).join("; ") + ".";
  }

  jQuery(".error_message").text(str);
  jQuery("#modalAddToCartError").modal("toggle");
  setTimeout(function () {
    jQuery(".shopping__cart").removeClass("shopping__cart__on");
    jQuery(".body__overlay").removeClass("is-visible");
  }, 2000);
};

Shopify.addItem = function (variant_id, quantity, callback) {
  var quantity = quantity || 1;
  var params = {
    type: "POST",
    url: "/cart/add.js",
    data: "quantity=" + quantity + "&id=" + variant_id,
    dataType: "json",
    success: function (line_item) {
      if (typeof callback === "function") {
        callback(line_item);
      } else {
        Shopify.cartPopap(variant_id);
        Shopify.onItemAdded(line_item);
      }
    },
    error: function (XMLHttpRequest, textStatus) {
      Shopify.onError(XMLHttpRequest, textStatus);
    },
  };
  jQuery.ajax(params);
};

Shopify.addItemFromForm = function (form_id, variant_id, callback) {
  var params = {
    type: "POST",
    url: "/cart/add.js",
    beforeSend: function () {
      if (form_id == "add-item-qv") {
        jQuery("#" + form_id)
          .find(".addtocartqv")
          .html(jQuery(".quickViewModal_info .button_wait").html());
      }
    },
    data: jQuery("#" + form_id).serialize(),
    dataType: "json",
    success: function (line_item) {
      if (typeof callback === "function") {
        callback(line_item);
      } else {
        if (form_id != "add-item-qv") {
          Shopify.cartPopapForm(variant_id);
        } else {
          jQuery("#" + form_id)
            .find(".addtocartqv")
            .html(jQuery(".quickViewModal_info .button_added").html());
          jQuery("#" + form_id)
            .find(".addtocartqv")
            .addClass("added_in_cart");
          setTimeout(function () {
            jQuery("#" + form_id)
              .find(".addtocartqv")
              .removeClass("added_in_cart");
            jQuery("#" + form_id)
              .find(".addtocartqv")
              .html(jQuery(".quickViewModal_info .button").html());
          }, 2000);
        }
        Shopify.onItemAdded(line_item);
      }
    },
    error: function (XMLHttpRequest, textStatus) {
      if (form_id != "add-item-qv") {
        Shopify.onError(XMLHttpRequest, textStatus);
      } else {
        jQuery("#" + form_id)
          .find(".addtocartqv")
          .html(jQuery(".quickViewModal_info .button_error").html());
        jQuery("#" + form_id)
          .find(".addtocartqv")
          .addClass("error_in_cart");
        setTimeout(function () {
          jQuery("#" + form_id)
            .find(".addtocartqv")
            .removeClass("error_in_cart");
          jQuery("#" + form_id)
            .find(".addtocartqv")
            .html(jQuery(".quickViewModal_info .button").html());
        }, 2000);
      }
      Shopify.onItemAdded(line_item);
    },
  };
  jQuery.ajax(params);
};

/* user functions */

Shopify.addItemFromFormStart = function (form, product_id) {
  Shopify.addItemFromForm(form, product_id);
};

Shopify.cartPopap = function (variant_id) {
  var image = jQuery("." + variant_id + ":first .popup_cart_image").attr("src");
  var title = jQuery("." + variant_id + ":first .popup_cart_title")
    .first()
    .text();
  jQuery(".popupimage").attr("src", "" + image + "");
  jQuery(".productmsg").text("" + title + "");
  jQuery("#modalAddToCart").modal("toggle");
};
Shopify.cartPopapForm = function (variant_id) {
  var image = jQuery(".product_variant_image").attr("src");
  var title = jQuery("#popup_cart_title").text();
  jQuery(".popupimage").attr("src", "" + image + "");
  jQuery(".productmsg").text("" + title + "");
  jQuery("#modalAddToCart").modal("toggle");
};

Shopify.cartUpdateInfo = function (cart, cart_cell_id) {
  var formatMoney = window.money_format;
  if (typeof cart_cell_id === "string") {
    var cart_cell = jQuery(cart_cell_id);
    if (cart_cell.length) {
      cart_cell.empty();

      jQuery.each(cart, function (key, value) {
        if (key === "items") {
          if (value.length == 1) {
            jQuery(".single-product-cart, .item-single-item-count").css({
              display: "block",
            });
            jQuery(".cart-empty-title, .item-multiple-item-count").css({
              display: "none",
            });

            var table = jQuery(cart_cell_id);
            jQuery.each(value, function (i, item) {
              if (i > 19) {
                return false;
              }
              jQuery(
                '<div class="cart_item"><div class="cart_img"><a href="' +
                  item.url +
                  '"><img src="' +
                  item.image +
                  '" alt=""></a></div><div class="cart_info"><a href="' +
                  item.url +
                  '">' +
                  item.title +
                  '</a><span class="quantity">Qty: ' +
                  item.quantity +
                  '</span><span class="price_cart">' +
                  Shopify.formatMoney(item.price, formatMoney) +
                  '</span></div><div class="cart_remove"><a href="javascript:void(0);" onclick="Shopify.removeItem(' +
                  item.variant_id +
                  ')"><i class="ion-android-close"></i></a></div></div>'
              ).appendTo(table);
            });
          } else if (value.length) {
            jQuery(".single-product-cart, .item-multiple-item-count").css({
              display: "block",
            });
            jQuery(".cart-empty-title,  .item-single-item-count").css({
              display: "none",
            });

            var table = jQuery(cart_cell_id);
            jQuery.each(value, function (i, item) {
              if (i > 19) {
                return false;
              }
              jQuery(
                '<div class="cart_item"><div class="cart_img"><a href="' +
                  item.url +
                  '"><img src="' +
                  item.image +
                  '" alt=""></a></div><div class="cart_info"><a href="' +
                  item.url +
                  '">' +
                  item.title +
                  '</a><span class="quantity">Qty: ' +
                  item.quantity +
                  '</span><span class="price_cart">' +
                  Shopify.formatMoney(item.price, formatMoney) +
                  '</span></div><div class="cart_remove"><a href="javascript:void(0);" onclick="Shopify.removeItem(' +
                  item.variant_id +
                  ')"><i class="ion-android-close"></i></a></div></div>'
              ).appendTo(table);
            });
          } else {
            jQuery(".single-product-cart, .item-single-item-count").css({
              display: "none",
            });
            jQuery(".cart-empty-title").css({ display: "block" });
          }
        }
      });
    }
  }

  changeHtmlValue(
    ".shopping-cart__total",
    Shopify.formatMoney(cart.total_price, formatMoney)
  );
  changeHtmlValue(".bigcounter", cart.item_count);

  jQuery(".currency .active").trigger("click");
};

//Utils
function changeHtmlValue(cell, value) {
  var $cartLinkText = jQuery(cell);
  $cartLinkText.html(value);
}
